var React = require('react');

function Send (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.33 0.670019C17.1408 0.482186 16.9035 0.35014 16.6442 0.288393C16.3849 0.226647 16.1135 0.23759 15.86 0.320019L1.23 5.20002C0.958673 5.28599 0.718908 5.45045 0.540989 5.67261C0.363071 5.89478 0.254981 6.16468 0.23037 6.44824C0.205759 6.7318 0.265732 7.01629 0.402714 7.26579C0.539696 7.51528 0.747543 7.71858 1 7.85002L7.07 10.85L10.07 16.94C10.1906 17.1784 10.3751 17.3785 10.6029 17.518C10.8307 17.6576 11.0929 17.731 11.36 17.73H11.46C11.7461 17.7089 12.0192 17.6023 12.2439 17.424C12.4686 17.2456 12.6345 17.0039 12.72 16.73L17.67 2.14002C17.7584 1.88795 17.7734 1.61596 17.7132 1.35572C17.653 1.09547 17.5201 0.857676 17.33 0.670019ZM1.85 6.58002L14.62 2.32002L7.53 9.41002L1.85 6.58002ZM11.43 16.15L8.59 10.47L15.68 3.38002L11.43 16.15Z","fill":"white"}));
}

Send.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Send;

Send.default = Send;
